/* BA-CUSTOM [ref: add2save-btn]
   WHAT: "ADD 2 & SAVE" button handler. Adds quantity 2 of the selected variant, then
         opens/refreshes the mini-cart via the theme's get_cart(). Falls back to /cart.
   WHY:  One-click "buy 2" path. Event-delegated + guarded so a single copy handles the
         PDP button and every collection-tile button. The saving itself is applied by an
         AUTOMATIC "buy 2 = 10% off" discount, not by this script.
   WHEN: 2026-07-16 */
(function () {
  // Distinct "blue outline" styling for the duo button so it's obviously different from the
  // solid Add to Cart. High-specificity + !important to beat the theme's button rules; hover/
  // focus/active invert to a blue fill for click feedback. Injected once for PDP + all tiles.
  try {
    var css = 'button.ba-add2-btn[data-ba-add2]{background:#ffffff !important;border:2px solid #1F5FE0 !important;color:#1F5FE0 !important;}'
            + 'button.ba-add2-btn[data-ba-add2] span{color:inherit !important;}'
            + 'button.ba-add2-btn[data-ba-add2]:hover,button.ba-add2-btn[data-ba-add2]:focus,button.ba-add2-btn[data-ba-add2]:active{background:#1F5FE0 !important;color:#ffffff !important;border-color:#1F5FE0 !important;}';
    var st = document.createElement('style'); st.setAttribute('data-ba-add2-css', ''); st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
  function resolveVariantId(btn) {
    // Tile: respect the colour the shopper picked (radio id is "radio_<variantId>")
    var card = btn.closest('.product-card-wrapper');
    if (card) {
      var r = card.querySelector('input[name^="single-varient"]:checked, input[name^="single-variant"]:checked');
      if (r && /^radio_/.test(r.id)) return r.id.replace('radio_', '');
    }
    // PDP: hidden variant <select> referenced by the button
    var selId = btn.getAttribute('data-add2-select');
    if (selId) { var s = document.getElementById(selId); if (s && s.value) return s.value; }
    // Explicit default on the button
    if (btn.getAttribute('data-add2-variant')) return btn.getAttribute('data-add2-variant');
    // Last resort: the nearest form's hidden id
    var f = btn.closest('form'); if (f) { var i = f.querySelector('[name="id"]'); if (i && i.value) return i.value; }
    return null;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ba-add2]');
    if (!btn) return;
    e.preventDefault();
    var id = resolveVariantId(btn);
    if (!id) return;
    // Guard against double-clicks WITHOUT a disabled state, so the button keeps the
    // exact same click/hover/active colours as the normal Add to Cart button.
    if (btn.getAttribute('data-ba-busy') === '1') return;
    btn.setAttribute('data-ba-busy', '1');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 2 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (typeof window.get_cart === 'function') { try { window.get_cart(); } catch (e) {} btn.removeAttribute('data-ba-busy'); }
        else { window.location.href = '/cart'; }
      })
      .catch(function () { btn.removeAttribute('data-ba-busy'); });
  });
})();
